import React from "react";
import { pointsConfig } from "../../../../pointsConfig";

function MilesRankDetailModalHeader() {
  return (
    <div className="p-4 w-full flex items-center gap-3 sticky top-0 bg-white">
      <img
        src={pointsConfig.ranks.legendary.icon}
        alt=""
        className="w-20 object-contain"
      />
      <div className="flex flex-1 flex-col gap-2">
        <div className="w-full flex items-center justify-between gap-2">
          <div className="flex flex-1 flex-col">
            <span className="font-BrFirmaBold">Company Name Here</span>
            <span className="text-[#606060]">
              {pointsConfig.ranks.legendary.label}
            </span>
          </div>
          <img src="/3rdTag.svg" alt="" className="h-14 object-contain -mr-4" />
        </div>
        <div className="w-full h-4">
          <div className="w-full h-full rounded-full bg-[#F3F5F9] font-bold relative">
            <div
              className={`h-full  rounded-full bg-[#06E775]`}
              style={{ width: `70%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MilesRankDetailModalHeader;
